import { Grid } from "@mui/material";
import AcxLoadingIndicator from "components/UI/AcxLoadingIndicator";
import AcxRecursiveTree from "components/UI/AcxRecursiveTree/AcxRecursiveTree";
import { Observer, observer } from "mobx-react";
import React, { useEffect } from "react";
import { IAcxHierarchyComponentProps } from "./AcxHierarchySelector";
import { HierarchyService } from "services/HierarchyService";

const HierarchySelectorTree: React.FC<IAcxHierarchyComponentProps> = observer(
    (props: IAcxHierarchyComponentProps) => {
        useEffect(() => {
            if (!props.viewOnly) {
                return;
            }

            const service = new HierarchyService();
            const originalTopLevelBranches = props.treeStore.topLevelBranches;

            props.treeStore.setIsTreeLoading(true);
            service
                .getTopLevelHierarchiesForUser(
                    false,
                    props.availableHierarchyIds ?? props.initSelectedHierarchyIds,
                )
                .then((hierarchies) => {
                    props.treeStore.setTopLevelBranches(
                        hierarchies.childrenHierarchies,
                    );
                })
                .finally(() => props.treeStore.setIsTreeLoading(false));

            return () => {
                if (originalTopLevelBranches)
                    props.treeStore.setTopLevelBranches(
                        originalTopLevelBranches,
                    );
            };
        }, [
            props.treeStore,
            props.viewOnly,
            props.initSelectedHierarchyIds,
            props.availableHierarchyIds,
        ]);

        return (
            <Observer>
                {() => (
                    <Grid
                        item
                        data-testid="hierarchy-selector-tree"
                        sx={{
                            height: "100%",
                            minHeight: 0,
                            overflowY: "auto",
                            overflowX: "hidden",
                            "@media (max-height: 600px)": {
                                minHeight: 0,
                            },
                        }}
                    >
                        {props.treeStore.isTreeLoading ? (
                            <Grid
                                item
                                container
                                justifyContent="center"
                                alignItems="center"
                                sx={(theme) => ({
                                    padding: theme.spacing(2),
                                    height: "100%",
                                })}
                            >
                                <AcxLoadingIndicator
                                    size={66}
                                    alternate="PuffLoader"
                                />
                            </Grid>
                        ) : (
                            <AcxRecursiveTree
                                viewOnly={props.viewOnly}
                                store={props.treeStore}
                            />
                        )}
                    </Grid>
                )}
            </Observer>
        );
    },
);

export default HierarchySelectorTree;
